// extracted by mini-css-extract-plugin
export default {"btn":"ApplicantContactsRow_btn__8eLwI","tr":"ApplicantContactsRow_tr__x4RGo","table-number-cell":"ApplicantContactsRow_table-number-cell__j90gj"};